function ComplimentaryRoomReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">ComplimentaryRoomReport</div>
      </>
    );
  }
  
  export default ComplimentaryRoomReport;